import React from "react";
import { RouterProvider, useNavigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./styles/theme";
import {
  AppInsightsContext,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./utils/ApplicationInsightsService";
import { SnackbarProvider } from "notistack";
import ErrorPage from "./components/shared/errorPage/ErrorPage";
import { useMsalEvents } from "hooks/useMSALEvents";
import { router } from "routes/Routes";
import { LicenseInfo } from "@mui/x-data-grid-pro";

function App({ pca }) {
  useMsalEvents(pca);

  LicenseInfo.setLicenseKey(
    '711f374df6b703ae814aece9d29767e7Tz0xMjc3MzgsRT0xODA4NTI0Nzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y'
  );

  return (
    <MsalProvider instance={pca}>
      <AppInsightsErrorBoundary appInsights={reactPlugin} onError={ErrorPage}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            autoHideDuration={3000}
            disableWindowBlurListener={true}>
              <RouterProvider router={router}>
                <ClientSideNavigation pca={pca}>
                  <AppInsightsContext.Provider value={reactPlugin}>
                    <div className="app"/>
                  </AppInsightsContext.Provider>
                </ClientSideNavigation>
              </RouterProvider>
            </SnackbarProvider>
        </ThemeProvider>
      </AppInsightsErrorBoundary>
    </MsalProvider>
  );
}

function ClientSideNavigation({ pca, children }) {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);

  return children;
}

export default App;
